import styled from "styled-components";

export const ContainerControls = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  padding: 10px;
  width: 98%;
`;



// WEBPACK FOOTER //
// ./src/components/styles/Player.js